import { fileSave } from "@/api/files.api";

const _getItem = (items, fieldNameId, id) => {
  for (let i = 0; i < items.length; i++) {
    if (items[i][fieldNameId] === id) {
      return items[i];
    }
  }
  return false;
};

const _setObjectField = (item, fieldName, value) => {
  let result = item;
  let fields = fieldName.split(".");
  for (let i = 0; i < fields.length; i++) {
    if (result.hasOwnProperty([fields[i]])) {
      if (i === fields.length - 1) {
        result[fields[i]] = value;
      } else {
        result = result[fields[i]];
      }
    } else {
      break;
    }
  }
};

const state = {
  requaredField: false,
  galleryList: {},
  filesToDelete: [],
  urlEditable: "",
  programList: {},
  fileList: {}
};

const getters = {};

const actions = {
  async uploadFile(undefined, { src, fileName, objectId, attributeId, lang }) {
    try {
      const response = await fileSave(
        src,
        fileName,
        lang,
        objectId,
        attributeId
      );
      return response.data;
    } catch (err) {
      return err.response;
    }
  }
};

const mutations = {
  clearObjectComplexValue(state) {
    state.galleryList = {
      gallery: []
    };
    state.filesToDelete = [];
    state.urlEditable = "";
    state.fileList = {
      file: []
    };
    state.programList = {};
    state.requaredField = false;
  },
  resetPreview(state) {
    state.galleryList.gallery.forEach(g => {
      g.preview = false;
    });
  },
  initGalleryList(state, initData) {
    state.galleryList = initData;
  },
  setGalleryList(state, gallery) {
    state.galleryList.gallery = gallery;
  },
  appendGalleryObject(state, obj) {
    state.galleryList.gallery.push(obj);
  },
  deleteGalleryObject(state, url) {
    let i = 0;
    for (i = 0; i < state.galleryList.gallery.length; i++) {
      if (state.galleryList.gallery[i].url === url) {
        state.galleryList.gallery.splice(i, 1);
        break;
      }
    }
  },
  updateGalleryItem(state, { url, fieldName, value }) {
    let item = _getItem(state.galleryList.gallery, "url", url);
    if (item) {
      _setObjectField(item, fieldName, value);
    }
  },
  appendFilesToDelete(state, url) {
    state.filesToDelete.push(url);
  },
  setUrlEditable(state, url) {
    state.urlEditable = url;
  },
  initProgramList(state, initData) {
    state.programList = initData;
  },
  setProgramList(state, program) {
    state.programList.program = program;
  },
  appendProgramObject(state, obj) {
    state.programList.program.push(obj);
  },
  deleteProgramObject(state, guid) {
    let i = 0;
    for (i = 0; i < state.programList.program.length; i++) {
      if (state.programList.program[i].guid === guid) {
        state.programList.program.splice(i, 1);
        break;
      }
    }
  },
  updateProgramItem(state, { guid, fieldName, value }) {
    let item = _getItem(state.programList.program, "guid", guid);
    if (item) {
      _setObjectField(item, fieldName, value);
    }
  },
  initFileList(state, initData) {
    state.fileList = initData;
  },
  appendFileList(state, fileObj) {
    state.fileList.file.push(fileObj);
  },
  updateFileItem(state, { guid, fieldName, value }) {
    let item = _getItem(state.fileList.file, "guid", guid);
    if (item) {
      _setObjectField(item, fieldName, value);
    }
  },
  setRequaredFieldComplexValue(state, val) {
    state.requaredField = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
